import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { Already3aNotAllowedGuard } from '@app/guards/already-3a.guard';
import { Already3bNotAllowedGuard } from '@app/guards/already-3b.guard';
import { AuthGuard } from '@app/guards/auth.guard';
import { GermanyNotAllowedGuard } from '@app/guards/germany-not-allowed.guard';
import { OnlyCustomersGuard } from '@app/guards/only-customers.guard';
import { SurveyDeactivateGuard, SurveyGuard } from '@app/guards/survey.guard';
import { FundWithdrawComponent } from '@app/modules/general/pages/fund-withdraw/fund-withdraw.component';
import { ReferralsComponent } from '@app/modules/general/pages/referrals/referrals.component';
import { VerifyEmailComponent } from '@app/modules/general/pages/verify-email/verify-email.component';

import { CrossSellingComponent } from './pages/cross-selling/cross-selling.component';
import { FundComponent } from './pages/fund/fund.component';
import { HelpComponent } from './pages/help/help.component';
import { ProductSwitchComponent } from './pages/product-switch/product-switch.component';
import { SurveyComponent } from './pages/survey/survey.component';

const routes: Routes = [
  { path: 'next/verify-email', component: VerifyEmailComponent, pathMatch: 'full', canActivate: [AuthGuard] },
  { path: 'help', component: HelpComponent, pathMatch: 'full', canActivate: [AuthGuard] },
  { path: 'contact', redirectTo: 'help', pathMatch: 'full' },
  {
    path: 'tell-friend',
    component: ReferralsComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'survey',
    component: SurveyComponent,
    pathMatch: 'full',
    canActivate: [SurveyGuard, AuthGuard],
    canDeactivate: [SurveyDeactivateGuard]
  },
  { path: 'next/fund', component: FundComponent, pathMatch: 'full', canActivate: [AuthGuard] },
  {
    path: 'adjust-investment',
    component: FundWithdrawComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard, OnlyCustomersGuard]
  },
  {
    path: 'product',
    pathMatch: 'full',
    canActivate: [AuthGuard],
    component: ProductSwitchComponent
  },
  {
    path: 'new-account/:kind',
    pathMatch: 'full',
    canActivate: [AuthGuard, GermanyNotAllowedGuard, Already3bNotAllowedGuard, Already3aNotAllowedGuard],
    component: CrossSellingComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GeneralRoutingModule {}
